import { clsx } from "clsx";
import { useEffect, useRef } from "react";

import { ClothingThemeData } from "../../data/clothing-theme/clothing-theme.data";
import * as styles from "./ThemeTabs.module.scss";

interface ThemeTabsProps {
  themes?: ClothingThemeData[];
  activeId: string;
  onChange: (id: string) => void;
}

export function ThemeTabs({ themes, activeId, onChange }: ThemeTabsProps) {
  const listRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const list = listRef.current;
    if (!list) return;
    const active = list.querySelector<HTMLButtonElement>(
      `[data-theme-id="${activeId}"]`,
    );
    if (!active) return;
    const target =
      active.offsetLeft - list.clientWidth / 2 + active.clientWidth / 2;
    list.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
  }, [activeId, themes]);

  return (
    <div className={styles.themeTabs}>
      <div className={styles.themeTabsList} ref={listRef}>
        {themes?.map((theme) => {
          const isActive = theme.id === activeId;
          return (
            <button
              key={theme.id}
              type="button"
              data-theme-id={theme.id}
              className={clsx(styles.themeTabsItem, {
                [styles.themeTabsItemActive]: isActive,
              })}
              onClick={() => onChange(theme.id)}
            >
              {theme.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
